export const createNoopController = () => {
  return Promise.resolve({
    pageReady: () => {
      return Promise.resolve();
    },
    exports: () => ({}),
  });
};
